/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ProductData, Groups, SprItem, ModelData } from '@ikea-aoa/component-view-3d';
import { validateJson } from '../JsonSchemaValidator';
import {
	GalleryItem,
	FunctionIcon,
	PredefinedConfiguration,
	RangeSettings,
} from 'sofa-reborn-react';
import { SofaIcons } from '../../typings/enums';
import { localeService } from '../../services';

function getFunctionIcons(config: any, id: string): FunctionIcon[] {
	const functionIcons: FunctionIcon[] = [];
	const item = config.spr.find((item: { id: string }) => item.id === id);
	if (item) {
		if (item.numberOfStorage > 0) {
			functionIcons.push({
				title: localeService.getTranslation('sprGalleryFunctionStorage'),
				icon: SofaIcons.FunctionStorageIcon,
				type: 'storage',
			});
		}
		if (item.numberOfSleep > 0) {
			functionIcons.push({
				title: localeService.getTranslation('sprGalleryFunctionSleep'),
				icon: SofaIcons.FunctionSleepIcon,
				type: 'sleep',
			});
		}
	}
	return functionIcons;
}

function parseSprItem(sprItem: any): SprItem {
	return Object.assign(sprItem, { qty: Number(sprItem.qty) });
}

export function parseGroups(config: any): Groups {
	const groupsData: Groups = config.groups;
	const result = validateJson('Groups', groupsData);
	if (!result.valid) {
		throw new Error(`ParsingError: ${result.error}`);
	} else {
		return groupsData;
	}
}

export function parseGalleryItems(config: any): GalleryItem[] {
	const galleryItemsData: GalleryItem[] = [];

	config.sprGallery.forEach((item: string) => {
		const galleryItem = {
			productItem: {
				id: item,
				type: 'SPR',
			},
			functionIcons: getFunctionIcons(config, item),
		};

		const result = validateJson('GalleryItem', galleryItem);
		if (result.valid) {
			galleryItemsData.push(galleryItem);
		}
	});

	return galleryItemsData;
}

export function getPredefinedConfigurations(config: any): PredefinedConfiguration[] {
	const sprConfigs: PredefinedConfiguration[] = [];
	config.spr.forEach((item) => {
		const result = validateJson('PredefinedConfiguration', item);
		if (result.valid) {
			sprConfigs.push(item);
		}
	});

	return sprConfigs;
}

export function getRangeSettings(config: any): RangeSettings {
	const settings: RangeSettings = config.settings.settings;

	if (settings && settings.rangeName === 'GRONLID') {
		settings.rangeName = 'GRÖNLID';
	}

	return settings;
}

export function parseModelData(config: any): ModelData {
	const modelData = config.models as ModelData;
	const result = validateJson('ModelData', modelData);
	if (!result.valid) {
		throw new Error(`ParsingError: ${result.error}`);
	}
	return modelData;
}

export function parseProductData(
	config: any,
	rangeSettings: RangeSettings,
	countryCode: string
): ProductData {
	const productData: ProductData = {};
	config.products.forEach((product: any) => {
		let sprItems = product.sprItems;
		if (sprItems && Array.isArray(sprItems)) {
			const temp: SprItem[] = [];
			sprItems.forEach((sprItem) => {
				const item = parseSprItem(sprItem);
				temp.push(item);
			});
			if (temp.length > 0) {
				sprItems = temp;
			}
		}

		const modelId =
			rangeSettings.change3DModel &&
			rangeSettings.change3DModel[countryCode] &&
			rangeSettings.change3DModel[countryCode][product.modelid]
				? rangeSettings.change3DModel[countryCode][product.modelid]
				: product.modelid;

		productData[product.id] = {
			productId: product.id,
			previousId: product.previousId || '',
			type: product.type,
			sprItems,
			filter: product.filter,
			modelId: modelId,
		};
	});

	const result = validateJson('ProductData', productData);
	if (!result.valid) {
		throw new Error(`ParsingError: ${result.error}`);
	} else {
		return productData;
	}
}
